import { getStoredUser } from "../utils/storage";
import { REACT_APP_X_API_KEY, HOST_TYPE } from "./apiPath";
import { getLocalTimeZone } from "./commonService";

// import storage from "redux-persist/lib/storage";
export default function authHeader(action) {
  const currentUser = getStoredUser();

  // const loginTime = JSON.parse(localStorage.getItem("userLoginTime"));

  // const currentTime = new Date().getTime();
  return {
    headers: {
      token: currentUser.token,
      action: action ? action : "",
      language: localStorage.getItem('i18nextLng'),
      'Accept-Language': localStorage.getItem('i18nextLng'),
      timezone: getLocalTimeZone(),
      'x-api-key': REACT_APP_X_API_KEY,
      'hosttype': HOST_TYPE,
      'ip': localStorage.getItem('userIP'),
      'device': navigator.userAgent
    },
  };
  // if (currentUser && currentUser.token) {
  //   let t = currentUser.expires_in + loginTime;
  //   if (currentTime > t) {
  //     localStorage.clear();
  //     storage.removeItem("persist:root");
  //     window.location.reload();
  //   } else {
  //     if (action) {
  //       return {
  //         headers: {
  //           Authorization: "Bearer " + currentUser.token,
  //           action: action ? action : "",
  //           language: "en",
  //         },
  //       };
  //     } else {
  //       return {
  //         headers: {
  //           Authorization: "Bearer " + currentUser.token,
  //           language: "en",
  //         },
  //       };
  //     }
  //   }
  // }
  // else {
  //   alert(5665);
  // }
}
